
import "./Header.css";
import ReactModal from "react-modal";
import React from "react";
import { useGlobalContext } from "../../context";

function Logout() {

    const {
        openLogout,
        setOpenLogout
    } = useGlobalContext()

    const close = () : void => {
        setOpenLogout(false);
    }

    const logout = () : void => {
        localStorage.removeItem("tkn");
        localStorage.removeItem("reftkn");
        localStorage.removeItem("roles");
        setOpenLogout(false);
        window.location.reload();
    }

    return (
        <ReactModal
            isOpen = { openLogout }
            onRequestClose = { close }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                Are you sure you want to log out?
            </div>
            <div className = 'modal-deleteClient-actions'>
                <button
                    className = "rejectAction"
                    onClick = { close }
                >
                    No
                </button>
                <button
                    className = "confirmAction"
                    onClick = { logout }
                >
                    Yes
                </button>
            </div>
        </ReactModal>
    )
}

export default Logout;
